<template>
  <div class="wrapper">
    <router-view />
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import { homeOnShowReporting } from "@/utils/reporting";
import { tdmInit } from "@/config/reporting.config.js";

onMounted(async () => {
  homeOnShowReporting();
  tdmInit();
});
</script>

<style scoped></style>
